"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiChariotResource_1 = require("./ApiChariotResource");
var class_validator_1 = require("class-validator");
var class_transformer_1 = require("class-transformer");
var ApiRuleConditionCriteria = /** @class */ (function () {
    function ApiRuleConditionCriteria() {
    }
    __decorate([
        (0, class_validator_1.IsString)(),
        (0, class_validator_1.IsUUID)(),
        __metadata("design:type", String)
    ], ApiRuleConditionCriteria.prototype, "id", void 0);
    __decorate([
        (0, class_validator_1.IsString)({ each: true }),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], ApiRuleConditionCriteria.prototype, "labels", void 0);
    return ApiRuleConditionCriteria;
}());
var ApiRuleConditionPointSelector = /** @class */ (function () {
    function ApiRuleConditionPointSelector() {
    }
    __decorate([
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleConditionCriteria)
    ], ApiRuleConditionPointSelector.prototype, "equipment", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleConditionCriteria)
    ], ApiRuleConditionPointSelector.prototype, "point", void 0);
    __decorate([
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleConditionCriteria)
    ], ApiRuleConditionPointSelector.prototype, "site", void 0);
    return ApiRuleConditionPointSelector;
}());
var ApiRuleCondition = /** @class */ (function () {
    function ApiRuleCondition() {
    }
    __decorate([
        (0, class_validator_1.IsDefined)(),
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleConditionPointSelector)
    ], ApiRuleCondition.prototype, "source", void 0);
    __decorate([
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleConditionPointSelector)
    ], ApiRuleCondition.prototype, "target", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        (0, class_validator_1.IsIn)(["EqualTo", "GreaterThan", "GreaterThanPoint", "LessThan", "LessThanPoint"]),
        __metadata("design:type", String)
    ], ApiRuleCondition.prototype, "type", void 0);
    __decorate([
        (0, class_validator_1.IsString)(),
        __metadata("design:type", String)
    ], ApiRuleCondition.prototype, "value", void 0);
    return ApiRuleCondition;
}());
var ApiRuleParentCondition = /** @class */ (function (_super) {
    __extends(ApiRuleParentCondition, _super);
    function ApiRuleParentCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.ValidateNested)({ each: true }),
        (0, class_transformer_1.Type)(function () { return ApiRuleCondition; }),
        __metadata("design:type", Array)
    ], ApiRuleParentCondition.prototype, "children", void 0);
    return ApiRuleParentCondition;
}(ApiRuleCondition));
var ApiRuleNotification = /** @class */ (function () {
    function ApiRuleNotification() {
        this.flightdeck = false;
    }
    __decorate([
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsString)({ each: true }),
        __metadata("design:type", Array)
    ], ApiRuleNotification.prototype, "email_list", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Object)
    ], ApiRuleNotification.prototype, "flightdeck", void 0);
    __decorate([
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.IsString)({ each: true }),
        __metadata("design:type", Array)
    ], ApiRuleNotification.prototype, "sms_list", void 0);
    return ApiRuleNotification;
}());
var ApiRule = /** @class */ (function (_super) {
    __extends(ApiRule, _super);
    function ApiRule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.grace = 0;
        _this.enabled = true;
        return _this;
    }
    __decorate([
        (0, class_validator_1.IsUUID)(),
        __metadata("design:type", String)
    ], ApiRule.prototype, "id", void 0);
    __decorate([
        (0, class_validator_1.IsUUID)(),
        __metadata("design:type", String)
    ], ApiRule.prototype, "client_id", void 0);
    __decorate([
        (0, class_validator_1.IsDefined)(),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.ValidateNested)({ each: true }),
        (0, class_transformer_1.Type)(function () { return ApiRuleParentCondition; }),
        __metadata("design:type", Array)
    ], ApiRule.prototype, "conditions", void 0);
    __decorate([
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.Validate)(/** @class */ (function () {
            function GraceValidator() {
            }
            GraceValidator.prototype.validate = function (value) {
                return value >= 0 && value % 5 === 0;
            };
            return GraceValidator;
        }()), {
            message: "Rule grace value must be divisible by 5"
        }),
        __metadata("design:type", Object)
    ], ApiRule.prototype, "grace", void 0);
    __decorate([
        (0, class_validator_1.IsString)(),
        __metadata("design:type", String)
    ], ApiRule.prototype, "name", void 0);
    __decorate([
        (0, class_validator_1.ValidateNested)(),
        __metadata("design:type", ApiRuleNotification)
    ], ApiRule.prototype, "notification", void 0);
    __decorate([
        (0, class_validator_1.IsUUID)(),
        __metadata("design:type", String)
    ], ApiRule.prototype, "owner", void 0);
    __decorate([
        (0, class_validator_1.IsString)(),
        (0, class_validator_1.IsIn)(["Critical", "High", "Low", "Normal"]),
        __metadata("design:type", String)
    ], ApiRule.prototype, "priority", void 0);
    __decorate([
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Object)
    ], ApiRule.prototype, "enabled", void 0);
    __decorate([
        (0, class_validator_1.IsUUID)(undefined, { each: true }),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], ApiRule.prototype, "users", void 0);
    return ApiRule;
}(ApiChariotResource_1.default));
exports.default = ApiRule;
